import { createFileRoute } from "@tanstack/react-router";
import IntegracionIaSeo from "@/pages/IntegracionIaSeo";
import { buildBreadcrumb, ldJson } from "@/lib/site-schema";

const canonicalUrl = "https://agenciaseoevolution.com/integracion-ia-seo";
const title = "Integración de IA en el SEO para empresas | SEOEVOLUTION";
const description =
  "SEO técnico, Google Maps y GEO integrados con IA. Evidencias reales de proyectos que aparecen en respuestas de IA de Google, sin garantías de citación.";

const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Integración de IA en el SEO",
  serviceType: "SEO y Generative Engine Optimization",
  provider: { "@type": "Organization", name: "SEOEVOLUTION", url: "https://agenciaseoevolution.com" },
  areaServed: { "@type": "Country", name: "España" },
  url: canonicalUrl,
  description,
};

export const Route = createFileRoute("/integracion-ia-seo")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: canonicalUrl },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
    ],
    links: [{ rel: "canonical", href: canonicalUrl }],
    scripts: [ldJson(buildBreadcrumb([{ name: "Integración de IA en el SEO", path: "/integracion-ia-seo" }])), ldJson(serviceSchema)],
  }),
  component: IntegracionIaSeo,
});
